import { bindRequestLogic } from './utils'
import Types from '../actionTypes/configPerTemplate'
import { configPerTemplateAPI } from '../api'

const getConfigPerTemplates = bindRequestLogic({
  clientFunc: configPerTemplateAPI.getConfigPerTemplates,
  type: Types.GET_CONFIG_PER_TEMPLATES_REQUEST,
  successType: Types.GET_CONFIG_PER_TEMPLATES_SUCCESS,
  failType: Types.GET_CONFIG_PER_TEMPLATES_FAILED,
  isQueryParam: true
})

const addConfigPerTemplate = bindRequestLogic({
  clientFunc: configPerTemplateAPI.addConfigPerTemplate,
  type: Types.ADD_CONFIG_PER_TEMPLATE_REQUEST,
  successType: Types.ADD_CONFIG_PER_TEMPLATE_SUCCESS,
  failType: Types.ADD_CONFIG_PER_TEMPLATE_FAILED
})

const getConfigPerTemplateDetail = bindRequestLogic({
  clientFunc: configPerTemplateAPI.getConfigPerTemplate,
  type: Types.GET_CONFIG_PER_TEMPLATE_DETAIL_REQUEST,
  successType: Types.GET_CONFIG_PER_TEMPLATE_DETAIL_SUCCESS,
  failType: Types.GET_CONFIG_PER_TEMPLATE_DETAIL_FAILED,
  modelName: 'configurationPersTemplate'
})

const updateConfigPerTemplate = bindRequestLogic({
  clientFunc: configPerTemplateAPI.updateConfigPerTemplate,
  type: Types.UPDATE_CONFIG_PER_TEMPLATE_REQUEST,
  successType: Types.UPDATE_CONFIG_PER_TEMPLATE_SUCCESS,
  failType: Types.UPDATE_CONFIG_PER_TEMPLATE_FAILED
})

const deleteConfigPerTemplate = bindRequestLogic({
  clientFunc: configPerTemplateAPI.deleteConfigPerTemplate,
  type: Types.DELETE_CONFIG_PER_TEMPLATE_REQUEST,
  successType: Types.DELETE_CONFIG_PER_TEMPLATE_SUCCESS,
  failType: Types.DELETE_CONFIG_PER_TEMPLATE_FAILED
})

export default [
  getConfigPerTemplates,
  addConfigPerTemplate,
  getConfigPerTemplateDetail,
  updateConfigPerTemplate,
  deleteConfigPerTemplate
]
